<template>
  <div id="form-cashout">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}   <b-badge variant="success" class="border-radius">New</b-badge></h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/new-reimbursement/general"
                >Reimbursement</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
      </b-row>
      <div class="border-bottom mb-2"></div>
      <b-row>
        <b-col md="8" class="mb-3">
          <div class="d-flex">
            <span class="my-3 dashboard-border"
              ><router-link to="/new-reimbursement/general">Requested Reimbursement</router-link></span
            >
            <span class="ml-4 my-3 dashboard-border"
              ><router-link to="/new-reimbursement/payment">Approved Reimbursement</router-link></span
            >
            <span class="ml-4 my-3 dashboard-border"
              ><router-link to="/new-reimbursement/history-reimbursement"
                >Paid Reimbursement</router-link
              ></span
            >
            <span class="ml-4 my-3 dashboard-border active"
              ><router-link
                to="/new-reimbursement/category-reimbursement"
                style="color:#0056b3!important;"
                >{{ $route.name }}</router-link
              ></span
            >
          </div>
        </b-col>
      </b-row>

      <h4 class="text-uppercase">Add Category</h4>
      <form v-on:submit.prevent="doSubmit()">
        <b-row>
          <b-col md="4">
            <div class="form-group" v-bind:class="errors.has('name') ? 'has-error' : ''">
              <label class="labels">category name*</label>
              <b-form-input
                v-model="model.categoryName"
                v-bind:class="errors.has('name') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="name"
                name="name"
                placeholder="category name"
                class="border-radius"
              />
              <p v-if="errors.has('name') !== null"></p>
            </div>
          </b-col>
          <b-col md="1"></b-col>
          <b-col md="4">
              <label class="labels">Note</label>
              <div
                class="form-group d-flex"
                v-bind:class="errors.has('note') ? 'has-error' : ''"
                style="height: 2.25rem;"
              >
              <b-form-textarea
              v-bind:class="errors.has('note') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="note"
                name="note"
                class="border-radius"
                v-model="model.categoryNote"
                placeholder="Note"
              >
              <p v-if="errors.has('note') !== null"></p>
              </b-form-textarea>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <div>
              <label class="labels">account</label>
              <div
                class="form-group d-flex"
                v-bind:class="errors.has('account') ? 'has-error' : ''"
                style="height: 2.25rem;"
              >
                <b-input
                  name="account"
                  v-bind:class="errors.has('account') ? 'is-invalid' : ''"
                  v-validate="'required'"
                  data-vv-as="account"
                  list="accounts"
                  class="w-100 border-radius"
                  v-model="model.accountNameSelected"
                  placeholder="Select Account Name"
                />
                <!-- <b-btn
                          class=" ml-1"
                          variant="outline-success"
                          @click.prevent="list.accountNameSelected = ''"
                        >
                          <i class="fas fa-check" style="font-size: 0.9rem"></i>
                        </b-btn> -->
                <datalist id="accounts">
                  <option
                    v-for="(account, index) in list.listAccount"
                    :key="index"
                    :value="account.text"
                  />
                </datalist>
                <p v-if="errors.has('account') !== null"></p>
              </div>
            </div>
          </b-col>

          <b-col md="1"> </b-col>
          <b-col md="3" class="mt-4">
            <div class="form-group" v-bind:class="errors.has('categoryIcon') ? 'has-error' : ''">
            <b-form-file
            v-bind:class="errors.has('categoryIcon') ? 'is-invalid' : ''"
            v-validate="'required'"
            data-vv-as="categoryIcon"
            name="categoryIcon"
              placeholder="Upload Category Icon"
              class="border-radius"
              v-model="model.categoryIcon"
              style="border-radius: 25px !important;"
              @change="previewImage"
             />
           <p v-if="errors.has('categoryIcon') !== null"></p>
            </div>
             <template v-if="preview">
                  <img :src="preview" class="w-50 mt-2" />
              </template>
              <template v-else>
                 <img class="w-50 mt-2" v-if="model.picture" :src="model.picture" />
              </template>
          </b-col>
          <b-button type="submit" variant="primary" class="border-radius h-25 mt-4"
            ><b-icon icon="plus" /> ADD</b-button
          >
        </b-row>
        <b-row class="mt-3 mb-5">
          <b-col md="12">
            <h4 class="text-uppercase">List Category</h4>
            <paginated-table
              :data-url="apiUrl.reimbursementCategory"
              :data-key="dataKey"
              :data-columns="columns"
            ></paginated-table>
          </b-col>
        </b-row>
      </form>
    </b-card>
  </div>
</template>

<script>
import PaginatedTable from '../../../components/PaginatedTable.vue';
export default {
  components: { PaginatedTable },
  data() {
    return {
      preview: '',
      dataKey: 'reimbursement_category',
      apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
        reimbursementCategory: window.AppConfig.apiUrl + 'reimbursement-category',
      },
      model: {
        accountNameSelected: '',
        categoryName: '',
        categoryNote: '',
        journalAccount: '',
        categoryIcon: '',
      },
      list: {
        accountNameSelected: '',
        listAccount: [],
      },
      columns: [
        {
          key: 'categoryName',
          label: 'category name',
          class: 'text-uppercase',
        },
        {
          key: 'journalAccount.journalAccountName',
          label: 'category account',
          class: 'text-uppercase',
        },
        {
          key: 'categoryNote',
          label: 'note',
          class: 'text-uppercase',
        },
        {
          key: 'actionCategoryReimburst',
          label: '',
          class: 'text-center',
        },
      ],
    };
  },

  mounted() {
    this.getAccountList();
  },

  methods: {
    getAccountList() {
      this.$http.get(this.apiUrl.account + '?journalAccountType=D').then((response) => {
        response?.data?._embedded?.journal_account?.forEach((data) => {
          this.list.listAccount.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountName,
          });
        });
      });
    },

    previewImage: function(event) {
    var input = event.target;
    if (input.files) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.preview = e.target.result;
      }
      this.model.categoryIcon=input.files[0];
      reader.readAsDataURL(input.files[0]);
      }
    },

    doSubmit() {
      let selected = this.model.accountNameSelected;
      this.model.journalAccount =
        this.list.listAccount.find((accountName) => {
          return accountName.text === selected;
        })?.value ?? null;
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('categoryName', this.model.categoryName);
          formData.append('journalAccount', this.model.journalAccount);
          formData.append('categoryNote', this.model.categoryNote);
          formData.append('categoryIcon', this.model.categoryIcon);
          this.$http.post(this.apiUrl.reimbursementCategory, formData).then((response) => {
            this.$store.dispatch('notification/success', 'Reimbursement Category has been added!');
            window.location.reload();
          });
        } else {
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },
  },
};
</script>
